import * as React from 'react';
import LinkElement from '../youwell-common/components/taskElements/LinkElement';
import { getVideos } from '../youwell-common/htmlUtils';
import { linkTypes } from '../youwell-common/constants';

const getTaskVideosFromHtmlContent = task => (task && task.contentElements && task.contentElements.reduce((prev, curr) => [...prev, ...getVideos(curr.htmlContent)], [])) || [];
const getTaskVideosFromLink = task => (task && task.contentElements && task.contentElements.reduce((prev, curr) => (curr.link && (curr.link.linkType === linkTypes.youtube || curr.link.linkType === linkTypes.vimeo || curr.link.linkType === linkTypes.video)
    ? [...prev, { Component: <LinkElement link={curr.link} /> }] : prev), [])) || [];

const getTaskVideos = (task) => {
    const videos = [];
    videos.push(...getTaskVideosFromHtmlContent(task).map(html => ({ html })));
    videos.push(...getTaskVideosFromLink(task));
    return videos;
};

export const getVideosForElement = (element) => {
    if (!element) {
        return [{
            none: true,
        }];
    }

    const videos = [];
    if (element.task && element.task.contentElements) {
        videos.push(...getTaskVideos(element.task));
    }
    if (element.module && element.module.tasks) {
        videos.push(...element.module.tasks.reduce((prev, curr) => [...prev, ...getTaskVideos(curr)], []));
    }
    if (videos.length === 0) {
        videos.push({
            none: true,
        });
    }
    return videos;
};

export const countVideos = elementList => (elementList ? elementList.reduce((prev, curr) => prev + getVideosForElement(curr).filter(d => !d.none).length,
    0) : 0);
